import { gql } from '@apollo/client';

export default gql`
  mutation deleteAdditionalDetails($bookingReference: String!, $additionalDetails: [InputAdditionalDetails]!) {
    deleteAdditionalDetails(bookingReference: $bookingReference, additionalDetails: $additionalDetails) {
      reference
    }
  }
`;
